<template>
  <div class="album-dialog">
    <el-dialog title="历史图片" :visible.sync="dialogVisiable" append-to-body width="60%">
      <div class="album-wrapper">
        <div class="img-list">
          <div v-for="(item, index) in imgList" :key="index" class="img-content" style="text-align: center">
            <div class="img-wrapper">
              <el-image :preview-src-list="[item.imgSrc]" :src="item.imgSrc" fit="fill" />
              <div class="psnr flex-start">
                <span class="title">PSNR:</span>
                <span class="value">{{ item.psnr || 0 }} dB</span>
              </div>
            </div>
            <p>第 {{ index + 1 }} 包</p>
          </div>
        </div>
        <div style="margin-top: 40px; display: flex; margin-right: 20px; flex-direction: row-reverse">
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisiable: false,
      imgList: [],
    };
  },
  methods: {
    open(imgList) {
      if (imgList && imgList.length > 0) {
        this.imgList = imgList;
      }
      this.dialogVisiable = true;
    },
    confirm() {
      this.dialogVisiable = false;
    },
  },
};
</script>
